import React from "react";
// eslint-disable-next-line
import { MouseEvent, useEffect, useMemo, useState } from "react";

// material-ui
import { useTheme } from "@mui/material/styles";
import {
  Chip,
  SnackbarProps,
  Stack,
  Tooltip,
  Typography,
  IconButton,
} from "@mui/material";
import _debounce from "lodash/debounce";
// third-party
import { ColumnDef } from "@tanstack/react-table";

import { Category } from "../../../../../types/Category";

import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { CustomerList } from "../../../../../types/customer";
import Loader from "../../../../../components/Loader";
import ExpandingCategoryDetail from "./ExpandingCategoryDetail";
import FormCustomerAdd from "./FormCustomerAdd";
import { FormattedMessage } from "react-intl";
import { USERAXIOS } from "../../../../../api/userAxios";
import ReusableTable from "../../../../../components/ReusableComponent/ReusableTable";
import { openSnackbar } from "../../../../../api/snackbar";
import ReusableDeleteDialog from "../../../../../components/ReusableComponent/ReusableDeleteDialog";
import { useQueryClient } from "@tanstack/react-query";

// ==============================|| CUSTOMER LIST ||============================== //

const Categories = ({ parentNumber }: { parentNumber?: number }) => {
  const theme = useTheme();
  const [open, setOpen] = useState<boolean>(false);

  const [customerModal, setCustomerModal] = useState<boolean>(false);
  const [selectedCustomer, setSelectedCustomer] = useState<CustomerList | null>(
    null
  );
  const [selected, setSelected] = useState<any>("");

  const handleClose = () => {
    setOpen(!open);
  };

  const columns = useMemo<ColumnDef<CustomerList>[]>(
    () => [
      {
        header: () => <FormattedMessage id="ID" />,
        accessorKey: "id",
        meta: {
          className: "cell-center",
        },
        cell: ({ row }) => (
          <Stack direction="row" spacing={1.5} alignItems="center">
            <Stack spacing={0}>
              <Typography variant="subtitle1">{row?.original.id}</Typography>
            </Stack>
          </Stack>
        ),
      },
      {
        header: () => <FormattedMessage id="English Name" />,
        accessorKey: "name",
        meta: {
          className: "cell-center",
        },
        cell: ({ row, getValue }) => (
          <Stack direction="row" spacing={1.5} alignItems="center">
            <Stack spacing={0}>
              <Typography variant="subtitle2">
                {getValue() as string}
              </Typography>
              <Typography color="text.secondary"></Typography>
            </Stack>
          </Stack>
        ),
      },
      {
        header: () => <FormattedMessage id="Arabic Name" />,
        accessorKey: "name_trans",
        meta: {
          className: "cell-center",
        },
        cell: ({ row, getValue }) => (
          <Stack direction="row" spacing={1.5} alignItems="center">
            <Stack spacing={0}>
              <Typography variant="subtitle2">
                {row.original?.name_trans?.ar}
              </Typography>
              <Typography color="text.secondary"></Typography>
            </Stack>
          </Stack>
        ),
      },
      {
        header: () => <FormattedMessage id="Parent Name" />,
        accessorKey: "parent",
        meta: {
          className: "cell-center",
        },
        cell: ({ row, getValue }) => (
          <Stack direction="row" spacing={1.5} alignItems="center">
            <Stack spacing={0}>
              <Typography variant="subtitle2">
                {getValue() === null
                  ? "No parent category"
                  : row.original.parent.name}
              </Typography>
            </Stack>
          </Stack>
        ),
      },
      {
        header: () => <FormattedMessage id="Order" />,
        accessorKey: "order",
        meta: {
          className: "cell-center",
        },
        cell: ({ row, getValue }) => (
          <Stack direction="row" spacing={1.5} alignItems="center">
            <Stack spacing={0}>
              <Typography variant="subtitle2">
                {getValue() as number}
              </Typography>
              <Typography color="text.secondary"></Typography>
            </Stack>
          </Stack>
        ),
      },
      {
        header: () => <FormattedMessage id="Status" />,
        accessorKey: "is_active",
        meta: {
          className: "cell-center",
        },
        cell: (cell) => {
          const isActive = cell.getValue();
          return (
            <Chip
              color={isActive ? "success" : "error"}
              label={
                isActive ? (
                  <FormattedMessage id="Active" />
                ) : (
                  <FormattedMessage id="Inactive" />
                )
              }
              size="small"
              variant="filled"
            />
          );
        },
      },
      {
        header: () => <FormattedMessage id="Actions" />,
        accessorKey: "actions",
        meta: {
          className: "cell-center",
        },
        disableSortBy: true,
        cell: ({ row }) => {
          // const collapseIcon =
          //   row.getCanExpand() && row.getIsExpanded() ? (
          //     <PlusOutlined
          //       style={{
          //         color: theme.palette.error.main,
          //         transform: "rotate(45deg)",
          //       }}
          //     />
          //   ) : (
          //     <EyeOutlined />
          //   );
          return (
            <Stack
              direction="row"
              // alignItems="center"
              // justifyContent="center"
              spacing={0}
            >
              {/* <Tooltip title="View">
                <IconButton
                  color="secondary"
                  onClick={row.getToggleExpandedHandler()}
                >
                  {collapseIcon}
                </IconButton>
              </Tooltip> */}
              <Tooltip title="Edit">
                <IconButton
                  color="primary"
                  onClick={(e: MouseEvent<HTMLButtonElement>) => {
                    e.stopPropagation();
                    setSelectedCustomer(row.original);
                    setCustomerModal(true);
                  }}
                  sx={{
                    "&:hover": {
                      backgroundColor: "transparent",
                    },
                  }}
                >
                  <EditOutlined />
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete">
                <IconButton
                  color="error"
                  onClick={(e: MouseEvent<HTMLButtonElement>) => {
                    e.stopPropagation();
                    handleClose();
                    setSelected(row.original);
                  }}
                >
                  <DeleteOutlined />
                </IconButton>
              </Tooltip>
            </Stack>
          );
        },
      },
    ],
    // eslint-disable-next-line
    [theme]
  );
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<Category[]>([]);
  const [countPage, setCountPage] = useState({
    current_page: 0,
    last_page: 0,
  });
  const [currentPage, setCurrenttPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchedtext, setSearchedtext] = useState("");
  const [loadingSearsh, setloadingSearsh] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [formLoading, setFormLoading] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const queryClient = useQueryClient();

  const handleDelete = async () => {
    if (!selected?.id) return;
    setIsDeleting(true);
    try {
      await USERAXIOS.delete(`/category/${selected?.id}`);
      setResult((prevResults: any[]) =>
        prevResults.filter((item) => item.id !== selected?.id)
      );
      queryClient.invalidateQueries({ queryKey: ["categories"] });

      openSnackbar({
        open: true,
        message: "Category deleted successfully",
        anchorOrigin: { vertical: "top", horizontal: "right" },
        variant: "alert",
        close: false,
        alert: {
          color: "success",
        },
      } as SnackbarProps);
      if (handleClose) handleClose();
    } catch (error: any) {
      openSnackbar({
        open: true,
        message: error?.response?.data?.message || "Failed to delete category",
        anchorOrigin: { vertical: "top", horizontal: "right" },
        variant: "alert",
        alert: {
          color: "error",
        },
      } as SnackbarProps);
    } finally {
      setIsDeleting(false);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await USERAXIOS.get(
        `/category?page=${currentPage}${
          searchQuery ? `&title=${searchQuery}` : ""
        }`
      );
      const { data, meta } = response.data;
      setResult(data);
      setCountPage(meta);
    } catch (error) {
      openSnackbar({
        open: true,
        message: "Error fetching articles",
        anchorOrigin: { vertical: "top", horizontal: "right" },
        variant: "alert",
        alert: {
          color: "error",
        },
      } as SnackbarProps);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, searchQuery]);

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setCurrenttPage(page);
  };

  const handleSearch = () => {
    setloadingSearsh(true);
    setCurrenttPage(1);
    setSearchQuery(searchedtext);
    setloadingSearsh(false);
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <ReusableTable
          data={result}
          columns={columns}
          countPage={countPage}
          handlePageChange={handlePageChange}
          handleSearchChange={handleSearch}
          currentPage={currentPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          setCurrenttPage={setCurrenttPage}
          loadingSearsh={loadingSearsh}
          searchedtext={searchedtext}
          setSearchedtext={setSearchedtext}
          modalToggler={() => {
            setCustomerModal(true);
            setSelectedCustomer(null);
          }}
          renderDetailPanel={({ row }: any) => (
            <ExpandingCategoryDetail data={row.original} />
          )}
        />
      )}
      <ReusableDeleteDialog
        title={selected?.name}
        open={open}
        handleClose={handleClose}
        handleDelete={handleDelete}
        isDeleting={isDeleting}
      />

      <FormCustomerAdd
        open={customerModal}
        setResult={setResult}
        loading={formLoading}
        setLoading={setFormLoading}
        fetchData={result}
        id={selected?.id}
        customer={selectedCustomer}
        handleClose={() => setCustomerModal(false)}
      />
    </>
  );
};

export default Categories;
